import { memo, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Button from "../../../components/Button";
import IconButton from "../../../components/IconButton";
import { ModalPopUp } from "../../../components/ModalPopUp";
import Spinner from "../../../components/Spinner";
import useAuthData from "../../../hook/useAppData";
import { IconCash, IconMenu, IconQuestion } from "../../../icons/index";
import Feedback from "./components/Feedback";
import { ModalVideo } from "../../../components/ModalVideo/Index";
import "./header.component.scss";

interface HeaderProps {
  title: string;
  setClosed: any;
}

function Header({ title, setClosed }: HeaderProps) {
  const { userName, userId, corporationCreatedBy, statusCorporation } = useAuthData();
  const [modalStatus, setModalStatus] = useState(false);
  // const [changeOptions, setChangeOptions] = useState(false);
  const name: string = userName || "user";
  const initialName = name[0].toUpperCase();
  const nameProfile = title;
  const [modalVideo, setModalVideo] = useState(false);

  function openSideBar() {
    setClosed((value: boolean) => !value);
  }

  function exitPopUp() {
    return setModalStatus(false);
  }

  const isCreatedOfThisCorporation = userId === corporationCreatedBy;

  const visiblePlanButton = !statusCorporation.planOk || statusCorporation.plan === "free";

  return (
    <>
      <ModalPopUp status={modalStatus} onClickCancel={exitPopUp}>
        <Feedback handleCancelClick={exitPopUp} />
      </ModalPopUp>
      {/* <ModalVideo modalVideo={true} setModalVideo={setModalVideo} videoUrl="../../../../../onboarding/Onboarding.mp4" /> */}

      <div className="headerContainer bg-secondary">
        <div className="headerContainer__content">
          <IconButton onClick={openSideBar} icon={IconMenu} className="menu" />

          <h1>{nameProfile}</h1>
        </div>
        <div className="flex gap-8">
          <Link
            to="/tutorial"
            // onClick={() => setModalVideo(true)}
            className="h-16 w-44 flex items-start justify-center text-2rem bg-primary rounded-xl px-4 py-2 shadow-xl pointer"
          >
            Tutorial
          </Link>
          {isCreatedOfThisCorporation && (
            <>
              {visiblePlanButton && (
                <Link
                  to="/payments"
                  className="h-16 w-44 flex items-start justify-center text-2rem bg-primary rounded-xl px-4 py-2 shadow-xl pointer"
                >
                  <span>Planos</span>
                  <IconButton icon={IconCash} className="mt-0 pr-0 iconCash" />
                </Link>
              )}
              {statusCorporation.planOk && statusCorporation.plan !== "free" && statusCorporation.plan !== "infinity" && (
                <Link
                  to="/payments-status"
                  className="h-16 w-44 flex items-start justify-center text-2rem bg-primary rounded-xl px-4 py-2 shadow-xl pointer"
                >
                  <span>Status</span>
                  <IconButton icon={IconCash} className="mt-0 pr-0 iconCash" />
                </Link>
              )}
            </>
          )}
        </div>

        <div className="headerContainer__content">
          <IconButton icon={IconQuestion} text="" className="questionIcon" onClick={() => setModalStatus(true)} />
          <Link to={`/collaborator/form/${userId}`} className="headerContainer__avatar bg-primary">
            {initialName}
          </Link>
          <span
          // className="flex items-center pointer" onClick={() => setChangeOptions((state) => !state)}
          >
            {name}
            {/* <IconButton icon={changeOptions ? IconArrowTop : IconArrowBottom} className="arrow-name" /> */}
          </span>
          {/* {changeOptions && (
            <div className="box-options bg-white px-4 py-2 rounded-xl fixed shadow-xl text-textPrimary w-68 text-lg">Pague o Aluguel seu misera</div>
          )} */}
        </div>
      </div>
    </>
  );
}

export default memo(Header);
